<template>
  <div class="risk-box">
    <el-form
      :disabled="isDialog || ossRiskIsEmpty"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="260px"
      class="ruleForm rmgt"
    >
      <div class="risk-tips">
        注：风控规则由向日葵平台保留最终解释权，所有风控内容最终以向日葵平台设置的可调范围为准。
      </div>

      <el-form-item
        label="下一任务间隔时间："
        v-if="showThePart('intervalTime') && ruleForm.intervalTime !== 0"
      >
        <el-input
          disabled
          :value="ruleForm.intervalTime || range.intervalTime"
          placeholder
        >
          <span slot="suffix">分钟</span>
        </el-input>
        <span class="note-s1">
          注：当前任务结束时间与下个任务开始时间间隔（线下场景生效）
        </span>
      </el-form-item>
      <el-form-item label="任务移动速度：" v-if="showThePart('taskMoveSpeed')">
        <span v-html="`平均速度≤`"></span>
        <el-input
          :value="ruleForm.taskMoveSpeed || range.taskMoveSpeed"
          disabled
          placeholder
          style="margin:0 12px"
        >
          <span slot="suffix">Km/小时</span>
        </el-input>
      </el-form-item>
      <el-form-item label="自然人年龄：" v-if="showThePart('ageStart')">
        <el-input
          disabled
          :value="ruleForm.ageStart || range.ageStart"
          placeholder
        >
          <span disabled slot="suffix">岁</span>
        </el-input>
        <span class="line"></span>
        <el-input disabled :value="ruleForm.ageEnd || range.ageEnd" placeholder>
          <span disabled slot="suffix">岁</span>
        </el-input>
      </el-form-item>

      <!-- 患者类型处理逻辑 -->
      <template v-if="isPatient">
        <el-form-item
          label="患者年龄："
          prop="patientAgeStart"
          :rules="validAge(ruleForm.patientAgeStart, ruleForm.patientAgeEnd)"
        >
          <el-input
            :disabled="!patientAgeIsUpdate"
            v-model="ruleForm.patientAgeStart"
          >
            <span slot="suffix">岁</span>
          </el-input>
          <span class="line"></span>
          <el-input
            :disabled="!patientAgeIsUpdate"
            v-model="ruleForm.patientAgeEnd"
          >
            <span disabled slot="suffix">岁</span>
          </el-input>
          <span
            class="note-s1"
            v-if="ajaxjResponse.patientAgeStart && ajaxjResponse.patientAgeEnd"
          >
            默认范围：{{ min }} - {{ max }}岁
          </span>
          <span v-else class="note-s1">
            默认不限制
          </span>
        </el-form-item>
        <el-form-item
          label="患者性别要求："
          prop="patientGender"
          :rules="validPatientGender()"
        >
          <el-checkbox-group
            :disabled="!patientGenderIsUpdate"
            v-model="ruleForm.patientGender"
          >
            <el-checkbox
              label="1"
              :disabled="ruleForm.basePatientGender.includes('1')"
            >
              男
            </el-checkbox>
            <el-checkbox
              label="2"
              :disabled="ruleForm.basePatientGender.includes('2')"
            >
              女
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </template>

      <el-form-item
        label="单日最多任务次数："
        prop="dayNumber"
        :rules="
          validVisitPeople(
            -1,
            range.dayNumberIsUpdate ? range.dayNumber : ruleForm.dayNumber,
            {
              empty: '请输入单日最多任务次数',
              notInteger: '单日最多任务次数需为正整数，请调整',
              tooMin: `单日最多任务次数最少为0次`,
              tooMax: `单日最多任务次数最多为${
                range.dayNumberIsUpdate ? range.dayNumber : ruleForm.dayNumber
              }次`
            }
          )
        "
        v-if="showThePart('dayNumber') && ruleForm.dayNumber !== 10000"
      >
        <el-input
          :disabled="!range.dayNumberIsUpdate"
          v-model="ruleForm.dayNumber"
          @blur="fommatNumber('dayNumber')"
          placeholder
          v-if="!!isDialog || range.dayNumberIsUpdate"
        >
          <span slot="suffix">次</span>
        </el-input>
        <el-input :disabled="true" v-model="range.dayNumber" placeholder v-else>
          <span slot="suffix">次</span>
        </el-input>
        <span v-if="range.dayNumber && !ossRiskIsEmpty" class="note-s1">
          默认范围：
          <template>
            <span v-if="range.dayNumber > 1">1 -</span>
            {{ `${range.dayNumber}次` }}
          </template>
        </span>
      </el-form-item>

      <el-form-item
        v-if="targetLimitShow"
        :label="`${targetLimitTitle}：`"
        prop="hospitalDayNumber"
        :rules="
          validVisitPeople(
            1,
            range.hospitalDayNumberIsUpdate
              ? range.hospitalDayNumber
              : ruleForm.hospitalDayNumber,
            {
              empty: '请输入次数',
              notInteger: '次数需为正整数，请调整',
              tooMin: `次数最少为1次`,
              tooMax: `次数最多为${
                range.hospitalDayNumberIsUpdate
                  ? range.hospitalDayNumber
                  : ruleForm.hospitalDayNumber
              }次`
            }
          )
        "
      >
        <el-input
          :disabled="!range.hospitalDayNumberIsUpdate"
          v-model="ruleForm.hospitalDayNumber"
          @blur="fommatNumber('dayNumber')"
          placeholder
          v-if="!!isDialog || range.hospitalDayNumberIsUpdate"
        >
          <span slot="suffix">次</span>
        </el-input>
        <el-input
          :disabled="true"
          v-model="range.hospitalDayNumber"
          placeholder
          v-else
        >
          <span slot="suffix">次</span>
        </el-input>
        <span v-if="range.hospitalDayNumber && !ossRiskIsEmpty" class="note-s1">
          默认范围：
          <template>
            <span v-if="range.hospitalDayNumber > 1">1 -</span>
            {{ `${range.hospitalDayNumber}次` }}
          </template>
        </span>
      </el-form-item>

      <el-form-item
        :label="
          range.customerRiskType == 2
            ? '每自然月相同目标最多任务次数：'
            : '不能有相同的任务目标：'
        "
        :prop="
          range.customerRiskType == 2 ? 'monthCustomerMostNumber' : 'dayDoctor'
        "
        :rules="
          range.customerRiskType == 2
            ? validVisitPeople3(
                range.monthCustomerMostNumberIsUpdate
                  ? range.monthCustomerMostNumber
                  : ruleForm.monthCustomerMostNumber,
                range.monthCustomerMostNumberIsUpdate ? ruleForm : range,
                !range.monthCustomerMostNumberIsUpdate
              )
            : validVisitPeople2(
                range.dayDoctorIsUpdate ? range.dayDoctor : ruleForm.dayDoctor,
                range.dayDoctorIsUpdate ? ruleForm : range,
                !range.dayDoctorIsUpdate
              )
        "
        v-if="showThePart('dayDoctor')"
      >
        <el-input
          :disabled="
            !range[
              range.customerRiskType == 2
                ? 'monthCustomerMostNumberIsUpdate'
                : 'dayDoctorIsUpdate'
            ]
          "
          v-model="
            ruleForm[
              range.customerRiskType == 2
                ? 'monthCustomerMostNumber'
                : 'dayDoctor'
            ]
          "
          @blur="
            fommatNumber(
              range.customerRiskType == 2
                ? 'monthCustomerMostNumber'
                : 'dayDoctor'
            )
          "
          placeholder
          v-if="
            !!isDialog ||
              range[
                range.customerRiskType == 2
                  ? 'monthCustomerMostNumberIsUpdate'
                  : 'dayDoctorIsUpdate'
              ]
          "
        >
          <span slot="suffix">
            {{ range.customerRiskType == 2 ? '次' : '天' }}
          </span>
        </el-input>
        <el-input
          :disabled="true"
          v-model="
            range[
              range.customerRiskType == 2
                ? 'monthCustomerMostNumber'
                : 'dayDoctor'
            ]
          "
          placeholder
          v-else
        >
          <span slot="suffix">
            {{ range.customerRiskType == 2 ? '次' : '天' }}
          </span>
        </el-input>
        <span
          v-if="
            +range[
              range.customerRiskType == 2
                ? 'monthCustomerMostNumber'
                : 'dayDoctor'
            ] >= 0 && !ossRiskIsEmpty
          "
          class="note-s1"
        >
          默认范围：
          <template v-if="range.customerRiskType == 2">
            <span v-if="range.monthCustomerMostNumber > 1">1 -</span>
            {{ `${range.monthCustomerMostNumber}次` }}
          </template>
          <template v-else>{{ `≥${range.dayDoctor}天` }}</template>
        </span>
      </el-form-item>
      <el-form-item
        prop="visitTime"
        label="拜访时长限制："
        v-if="isTimeSlotTypeShow"
        :rules="validTimeSlotQuestion(ruleForm)"
      >
        <el-input
          onkeyup="this.value = this.value.replace(/[^0-9]/g,'');"
          :maxlength="4"
          v-model="ruleForm.visitTimeStart"
          :disabled="!range.visitTimeIsUpdate"
          placeholder
        >
          <span slot="suffix">分钟</span>
        </el-input>
        <span class="line"></span>
        <el-input
          onkeyup="this.value = this.value.replace(/[^0-9]/g,'');"
          :maxlength="4"
          v-model="ruleForm.visitTimeEnd"
          :disabled="!range.visitTimeIsUpdate"
          placeholder
        >
          <span disabled slot="suffix">分钟</span>
        </el-input>
        <span
          v-if="visitTimeRange.max && !isDialog && !ossRiskIsEmpty"
          class="note-s1"
        >
          默认范围：{{ visitTimeRange.min }}-{{ visitTimeRange.max }}分钟
        </span>
      </el-form-item>
      <el-form-item
        label="任务执行时间："
        prop="startTime"
        :rules="
          validVisitTime(
            range.startTime,
            range.endTime ? range.endTime : range.entTime,
            ruleForm.startTime,
            ruleForm.endTime,
            range.timeIsUpdate
          )
        "
        v-if="showThePart('startTime')"
      >
        <div class="form-item-flex">
          <el-time-picker
            value-format="HH:mm"
            format="HH:mm"
            :class="{ 'hidden-ss': ruleForm.startTime }"
            :disabled="!range.timeIsUpdate"
            v-model="ruleForm.startTime"
            :picker-options="timeSelectOptions"
            placeholder="选择时间"
            v-if="!!isDialog || range.timeIsUpdate"
          ></el-time-picker>
          <el-time-picker
            v-else
            value-format="HH:mm"
            format="HH:mm"
            :class="{ 'hidden-ss': ruleForm.startTime }"
            :disabled="true"
            v-model="range.startTime"
            :picker-options="timeSelectOptions"
            placeholder="选择时间"
          ></el-time-picker>
          <span class="line"></span>
          <el-time-picker
            value-format="HH:mm"
            format="HH:mm"
            :class="{ 'hidden-ss': ruleForm.endTime }"
            :disabled="!range.timeIsUpdate"
            v-model="ruleForm.endTime"
            :picker-options="timeSelectOptions"
            placeholder="选择时间"
            v-if="!!isDialog || range.timeIsUpdate"
          ></el-time-picker>
          <el-time-picker
            v-else
            value-format="HH:mm"
            format="HH:mm"
            :class="{ 'hidden-ss': ruleForm.endTime }"
            :disabled="true"
            v-model="range.endTime"
            :picker-options="timeSelectOptions"
            placeholder="选择时间"
          ></el-time-picker>
          <span
            class="note-s1"
            v-if="range.startTime && !isDialog && !ossRiskIsEmpty"
          >
            默认范围：{{ range.startTime }}-{{
              range.endTime ? range.endTime : range.entTime
            }}
          </span>
        </div>
      </el-form-item>
      <template v-if="!isDialog">
        <el-form-item>
          <!--          {{ruleForm.enableDt|time}}-->
          <span style="color:#9D9D9D">注：所有修改内容将于次日0:00生效</span>
        </el-form-item>
        <div style="display: flex;justify-content: center">
          <el-button
            type="primary"
            class="bts"
            @click="save"
            :disabled="
              !patientAgeIsUpdate &&
                !patientGenderIsUpdate &&
                !range.timeIsUpdate &&
                !range.dayDoctorIsUpdate &&
                !range.dayNumberIsUpdate &&
                !range.monthCustomerMostNumberIsUpdate &&
                !range.hospitalDayNumberIsUpdate &&
                !range.visitTimeIsUpdate
            "
          >
            保存
          </el-button>
          <el-button type="primary" class="bts" @click="record">
            风控记录
          </el-button>
        </div>
      </template>
    </el-form>
  </div>
</template>

<script>
import { riskControl } from '@/api/ajax';
import { makeSure } from '@/Mixin/makeSure';
import mixins from '../mixins/index';

export default {
  mixins: [makeSure, mixins],
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: function() {
        return {};
      }
    },

    listobj: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      ossRiskIsEmpty: false,
      isTimeSlotTypeShow: false, //是否展示时间段的限制
      min: 1,
      max: 99
    };
  },
  computed: {
    targetLimitConfig() {
      return {
        1: { title: '同一医院单日拜访次数' },
        2: { title: '同一医院单日拜访次数' },
        3: { title: '同一医疗机构单日拜访次数' },
        9: { title: '同一公司单日拜访次数' },
        10: { title: '同一药店单日拜访次数' }
      };
    },
    showTargetTypes() {
      return Object.keys(this.targetLimitConfig).map(i => +i);
    },
    targetLimitShow() {
      const info = (this.ajaxjResponse || {}).tsaasMakeSceneBaseProject || {};
      return (
        this.showTargetTypes.includes(info.targetType) &&
        info.isSetTarget == 1 &&
        info.isSetTime == 1
      );
    },
    targetLimitTitle() {
      const info = (this.ajaxjResponse || {}).tsaasMakeSceneBaseProject || {};
      return (this.targetLimitConfig[info.targetType] || {}).title;
    },
    riskConfig() {
      const { isSetLocation = 0, isSetTarget = 0, isSetTime = 0 } =
        (this.ajaxjResponse || {}).tsaasMakeSceneBaseProject || {};
      const str = `${isSetTarget}${isSetTime}${isSetLocation}`; // 是否有目标题、时间题、定位题，对应位置1=>有
      return ({
        111: {
          objName: '目标+时间+地点',
          showPart: [
            'ageStart',
            'intervalTime',
            'taskMoveSpeed',
            'dayNumber',
            'dayDoctor',
            'startTime'
          ]
        },
        110: {
          objName: '目标+时间',
          showPart: [
            'ageStart',
            'intervalTime',
            'dayNumber',
            'dayDoctor',
            'startTime'
          ]
        },
        101: {
          objName: '目标+地点',
          showPart: ['ageStart']
        },
        '011': {
          objName: '时间+地点',
          showPart: [
            'ageStart',
            'intervalTime',
            'taskMoveSpeed',
            'dayNumber',
            'startTime'
          ]
        },
        100: {
          objName: '目标',
          showPart: ['ageStart']
        },
        '010': {
          objName: '时间',
          showPart: ['ageStart', 'intervalTime', 'dayNumber', 'startTime']
        },
        '001': {
          objName: '地点',
          showPart: ['ageStart']
        }
      }[str] || {})['showPart'];
    },
    // 是否是患者类型
    isPatient() {
      const info = (this.ajaxjResponse || {}).tsaasMakeSceneBaseProject || {};
      return +info.targetType === 13;
    },
    // 患者类型，年龄是否可以编辑
    patientAgeIsUpdate() {
      return (this.ajaxjResponse || {}).patientAgeIsUpdate;
    },
    // 患者类型，性别是否可以编辑
    patientGenderIsUpdate() {
      return (this.ajaxjResponse || {}).patientGenderIsUpdate;
    }
  },
  methods: {
    validAge(ageStart, ageEnd) {
      return [
        {
          validator: (rule, value, callback) => {
            if (
              !this.ajaxjResponse.patientAgeStart &&
              !this.ajaxjResponse.patientAgeEnd &&
              !ageStart &&
              !ageEnd
            ) {
              return callback();
            }

            const start = +ageStart;
            const end = +ageEnd;
            const isStartValid =
              /^\d+$/.test(ageStart) && start >= this.min && start <= this.max;
            const isEndValid =
              /^\d+$/.test(ageEnd) && end >= this.min && end <= this.max;

            if (isStartValid && isEndValid && start < end) {
              callback();
            } else {
              callback(
                new Error(
                  `年龄需为${this.min}-${this.max}正整数，且后者需大于前者`
                )
              );
            }
          },
          trigger: 'change'
        }
      ];
    },
    validPatientGender() {
      return [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (value && value.length) {
              callback();
            } else {
              callback(new Error('请选择患者性别要求'));
            }
          }
        }
      ];
    },
    showThePart(partName) {
      if (Array.isArray(this.riskConfig)) {
        return this.riskConfig.includes(partName);
      }
      console.warn('riskConfig is not Arrry');
      return false;
    },
    fommatNumber(key) {
      this.ruleForm[key] = `${this.ruleForm[key] || 0}`.replace(/[^0-9]/g, '');
    },
    save() {
      let curr = this.$parent.curr;
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          try {
            let operation = () => {
              const {
                dayNumber,
                monthCustomerMostNumber,
                startTime,
                endTime,
                dayDoctor,
                hospitalDayNumber,
                visitTimeStart,
                visitTimeEnd
              } = this.ruleForm;
              let obj = {
                hospitalDayNumber,
                dayNumber,
                startTime,
                endTime,
                dayDoctor,
                monthCustomerMostNumber,
                projectId: +(this.id || 0),
                projectType: 20,
                visitTimeStart,
                visitTimeEnd
              };

              // 患者类型特殊处理
              if (this.isPatient) {
                const {
                  patientAgeStart,
                  patientAgeEnd,
                  patientGender
                } = this.ruleForm;

                const updatedPatientGender =
                  patientGender.length === 2 ? '3' : String(patientGender);

                obj = {
                  ...obj,
                  patientAgeStart,
                  patientAgeEnd,
                  patientGender: updatedPatientGender
                };
              }

              riskControl[curr].update(obj).then(() => {
                this.$message.success('操作成功');
              });
            };
            this.makeSureEvent(operation, null, '确定修改?');
          } catch (e) {
            console.error('解析json有误');
          }
        }
      });
    },
    /**
     * @description: 根据平台风控格式化服务商数据
     * @returns {*}
     */
    formatRuleForm() {
      const {
        patientAgeStart,
        patientAgeEnd,
        patientGender
      } = this.ajaxjResponse;
      const {
        patientAgeStart: currentAgeStart,
        patientAgeEnd: currentAgeEnd,
        patientGender: currentGender
      } = this.ruleForm;

      // 使用逻辑或运算符来简化属性的赋值
      this.ruleForm.patientAgeStart = currentAgeStart || patientAgeStart;
      this.ruleForm.patientAgeEnd = currentAgeEnd || patientAgeEnd;
      this.ruleForm.patientGender = currentGender || patientGender;

      // 性别处理，如果平台风控只有一项则赋值给ASP，并且禁用性别选项
      if (patientGender && +patientGender !== 3) {
        this.ruleForm.patientGender = patientGender;
      }

      // 年龄处理
      if (
        patientAgeStart &&
        // 平台开始的值比ASP开始值大
        (+patientAgeStart > +currentAgeStart ||
          // ASP开始值比平台结束值大
          +currentAgeStart >= +patientAgeEnd)
      ) {
        this.ruleForm.patientAgeStart = patientAgeStart;
      }

      if (
        patientAgeEnd &&
        // 平台结束的值比ASP结束值小  ||  ASP结束值比平台开始值小
        (+patientAgeEnd < +currentAgeEnd || +currentAgeEnd <= +patientAgeStart)
      ) {
        this.ruleForm.patientAgeEnd = patientAgeEnd;
      }
    },

    /**
     * @description: 患者类型初始化数据， ASP 可以编辑患者年龄、患者性别，但是编辑的范围只能比平台 设置的风控严格
     * @returns {*}
     */
    initPatient(data) {
      if (!this.isPatient) return;

      const sexMap = {
        1: ['1'],
        2: ['2'],
        3: ['1', '2']
      };

      this.$set(
        this.ruleForm,
        'patientGender',
        data.patientGender ? sexMap[+data.patientGender] : []
      );

      const ossPatientGender =
        this.ajaxjResponse.patientGender &&
        +this.ajaxjResponse.patientGender !== 3;
      this.$set(
        this.ruleForm,
        'basePatientGender',
        // ASP 只能比 OSS 更严格，如果只有一个性别选项则禁用性别复选框
        ossPatientGender ? ['1', '2'] : []
      );

      this.$set(this.ruleForm, 'patientAgeStart', data.patientAgeStart);
      this.$set(this.ruleForm, 'patientAgeEnd', data.patientAgeEnd);

      this.min = this.ajaxjResponse.patientAgeStart || 1;
      this.max = this.ajaxjResponse.patientAgeEnd || 99;
    },
    initCallback() {
      if (
        !this.range['taskMoveSpeed'] &&
        !this.range['intervalTime'] &&
        !this.range['ageEnd']
      ) {
        // oss的风控还未生效
        this.ossRiskIsEmpty = true;
        Object.keys(this.range).forEach(item => {
          this.ruleForm[item] = '待生成';
          this.range[item] = '待生成';
        });
      }

      this.formatRuleForm();
      this.initPatient(this.ruleForm);
    }
  },
  watch: {
    'ajaxjResponse.tsaasMakeSceneBaseProject': {
      handler(v) {
        if (+v.timeType === 1) {
          this.isTimeSlotTypeShow = true;
        }
      }
    }
  }
};
</script>
<style lang="scss">
.rmgt {
  .el-input__suffix {
    right: 12px;
    color: #000;
  }
}

.risk-box {
  .ruleForm .el-form-item .el-input {
    width: 160px;
  }
}
</style>
<style scoped lang="scss">
.ruleForm {
  padding: 0;
}

.risk-tips {
  color: #9d9d9d;
  font-size: 13px;
  margin-bottom: 40px;
}

.note-s1 {
  margin-left: 30px;
  color: #9d9d9d;
  font-size: 13px;
}

.distance {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.check {
  position: absolute;
  right: 30.68%;
}

.line {
  width: 16px;
  height: 1px;
  background: #dedede;
  margin: 0 12px;
  display: inline-block;
}
.form-item-flex .el-input--prefix.hidden-ss::after {
  content: none;
}
</style>
